import { CognitoUser, CognitoUserSession } from 'amazon-cognito-identity-js';

import { Cognito } from '@fhs-legacy/frontend/src/utils/cognito';
import logger from '@fhs-legacy/frontend/src/utils/logger';

const getCognitoUserForUsername = (username: string): CognitoUser => {
  return new CognitoUser({
    Username: username,
    Pool: Cognito.userPool(),
    Storage: Cognito.storage,
  });
};

export const cognitoSignIn = async (
  cognitoId,
  sessionId,
  challengeCode
): Promise<CognitoUserSession | undefined> => {
  return new Promise((resolve, reject) => {
    const cognitoUser = getCognitoUserForUsername(cognitoId);
    /**
     * This is a hack we want to avoid in the future, but we need to maintain for backwards compatability.
     * This forces the sessionId in the frontend to match what the backend used to start the authentication request.
     */
    // @ts-expect-error TS(2339) FIXME: Property 'Session' does not exist on type 'Cognito... Remove this comment to see the full error message
    cognitoUser.Session = sessionId;

    cognitoUser.sendCustomChallengeAnswer(challengeCode, {
      onSuccess: session => {
        resolve(session);
      },
      onFailure: error => {
        //Log Cognito sign in failures to Datadog.
        logger.error({ message: 'Client-side cognito request failed', error });
        reject(error);
      },
    });
  });
};
